import PageWithTable from '@/src/Common/components/PageWithTable';
import OrgsTable from './OrgsTable';
import { Button } from '@/src/shadComponents/ui/button';
import { NavLink } from 'react-router-dom';

export default function OrgsList() {
    const actions = (
        <div className="flex justify-end">
            <NavLink to="create">
                <Button>Create Org</Button>
            </NavLink>
        </div>
    );

    return (
        <PageWithTable title="Organization Administration" actions={actions} breadcrumbs={[{ label: 'Admin', href: '/admin/orgs' }, { label: 'Organizations' }]}>
            <OrgsTable />
        </PageWithTable>
    );
}
